export const EVENT_SHOW_MINI_CART = "show-mini-cart";
export const EVENT_ADD_TO_CART = "eggo-add-to-cart";
export const EVENT_SHOW_QUANTITY_UPSELL = "eggo-show-quantity-upsell";
export const EVENT_TOGGLE_CHECKOUT = "eggo-toggle-checkout";

/** Fired by assets/cart.js after the cart page re-rendered its sections. */
export const EVENT_CART_PAGE_RENDERED = "eggo-cart-rendered";

export const documentEventDispatcher = (eventName, data) => {
    const showMiniCartEvent = new CustomEvent(eventName, {'detail': data});
    document.dispatchEvent(showMiniCartEvent);
}
